/**
 * The one permission check every list/drawer/menu item in the kit uses to
 * decide whether to render at all (ui-contract.md sections 1-2: "An item
 * appears only when the user holds that page's service"). Hiding, not merely
 * disabling - the interface never shows an action the user cannot perform.
 * Ported from the Unified Access web kit (`components/shared/permissions.ts`).
 */
export interface PermissionSubject {
  services?: readonly string[];
}

export function can(subject: PermissionSubject | null | undefined, service: string): boolean {
  if (!subject) return false;
  return subject.services?.includes(service) ?? false;
}
